import React, { useState } from 'react';
import styles from './QueueInfoDetails.module.scss';
import {StandardButton} from '../Button';
import { QrGenerator } from '../QrCode';
import { QueueList } from '../../Pages/Host/QueueManagement/QueueList'


const DetailRow = ({ title, value, large, valueId }) => (
  <div className={styles['detail-row']}>
    <span className={styles['detail-name']}>{title}</span>
    <span
      className={`${styles['detail-value']} ${
        large ? styles['large-value'] : ''
      }`}
      data-testid={valueId}
    >
      { value || value === 0 ? value : ''}
    </span>
  </div>
);

function QueueInfoDetails ({ queueInfo, isAdmin }){
  const [showQrCodeModal, setShowQrCodeModal] = useState(false);

  const generateQrCOde = () => {
    setShowQrCodeModal(true);
  };

  const {
    status,
    limit,
    activeGuests,
    totalGuests,
    queueId,
    organization
  } = queueInfo;

  let availableSlots = 0;
  if (limit === "Unlimited")
    availableSlots = "Unlimited";
  else availableSlots = limit - activeGuests;
  return (
    <div className={`${styles['queue-detail']} `}>
      <DetailRow title="Queue code:" value={queueId} />
      <DetailRow title="Queue status:" value={status?status.toUpperCase():''} />
      <DetailRow title="Available Slots:" value={availableSlots} valueId="slots-value" />
      <DetailRow title="Current number of people:" value={activeGuests || 0} />
      {isAdmin&&<DetailRow title="Total number of people:" value={totalGuests || 0} />}
      {isAdmin&&<DetailRow title="Organization Name:" value={organization?organization.orgName: '-'} />}
      
      {isAdmin &&
        <div className={'d-flex justify-content-center mt-3'}>
          <div className={styles['queue-buttons']}>
            <StandardButton onClick={generateQrCOde} >
              Show QR Code
            </StandardButton>
            {showQrCodeModal && (
               <QrGenerator queueId={queueId} show={showQrCodeModal} onClose={setShowQrCodeModal} />
            )}
          </div>
        </div>}
    </div>

  );
  
};

export default QueueInfoDetails
